import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {url} from '../../../../services/url'
import axios from 'axios'

const endpoint = `${url}/suppliers`
axios.defaults.withCredentials = true

export const getAll = createAsyncThunk('suppliers/all', async params => {
  const response = await axios.get(endpoint, {params})
  return { allData: response.data.data, data: response.data.data, totalPages: response.data.total, params }
})

export const getAllSuppliers = createAsyncThunk('listSuppliers', async () => {
  const response = await axios.get(`${url}/suppliers`)
  return response
})

export const get = createAsyncThunk('get', async id => {
  const response = await axios.get(`${endpoint}/${id}`, { id })
  return response.data
})

export const add = createAsyncThunk('add', async (item, { dispatch }) => {
  await axios.post(endpoint, item)
  await dispatch(getAll())
  await dispatch(getAllSuppliers())
  return item
})

export const update = createAsyncThunk('update', async (item, { dispatch }) => {
  await axios.put(`${endpoint}/${item.id}`, item)
  await dispatch(getAll())
  return item
})

export const remove = createAsyncThunk('remove', async (item, { dispatch }) => {
  await axios.delete(`${endpoint}/${item.id}`)
  await dispatch(getAll())
  return item
})

export const suppliersSlice = createSlice({
  name: 'suppliers',
  initialState: {
    data: [],
    status: 'READY',
    total: 1,
    params: {},
    selected: null,
    error: '',
    allSuppliers: [],
    remove: {
      statusText: '',
      payload: ''
    },
    add: {
      statusText: '',
      payload: ''
    },
    update: {
      statusText: '',
      payload: ''
    }
  },
  reducers: {},
  extraReducers: builder => {
    builder
        .addCase(getAll.fulfilled, (state, action) => {
          state.data = action.payload.data
          state.params = action.payload.params
          state.total = action.payload.totalPages
            state.status = 'READY'
        })
        .addCase(getAll.pending, (state) => {
            state.loading = true
            state.status = 'PENDING'
        })
        .addCase(get.fulfilled, (state, action) => {
          state.status = 'READY'
          state.selected = action.payload
        })
        .addCase(add.fulfilled, (state, action) => {
            state.selected = action.payload
            state.status = 'SUCCESS'
            state.add.statusText = `SUCCESS ${Math.random()}`
        })
        .addCase(add.rejected, (state, action) => {
            state.status = 'ERROR'
            state.add.statusText = `ERROR ${Math.random()}`
            state.error = action.payload || 'nao deu'
            state.loading = false
        })
        .addCase(update.fulfilled, (state, action) => {
          state.selected = action.payload
          state.status = 'SUCCESS'
          state.update.statusText = `SUCCESS ${Math.random()}`
        })
        .addCase(update.rejected, (state, action) => {
          state.selected = action.error
          state.status = 'ERROR'
          state.update.statusText = `ERROR ${Math.random()}`
        })
        .addCase(remove.fulfilled, (state, action) => {
          state.remove.payload = action.payload
          state.remove.statusText = `Success ${Math.random()}`
        })
        .addCase(remove.rejected, (state, action) => {
          state.selected = action.error
            state.status = 'ERROR'
        })
        .addCase(getAllSuppliers.fulfilled, (state, action) => {
          state.allSuppliers = action.payload.data
          state.status = 'READY'
        })
        .addCase(getAllSuppliers.pending, (state) => {
          state.loading = true
          state.status = 'PENDING'
        })
  }
})

export default suppliersSlice.reducer
